<template>
  <div id="visitObject">
    <!-- <el-dialog
      :visible.sync="showDialogVisible"
      :close-on-click-modal="false"
      width="240px"
      height="300px"
    >
      <el-form inline size="small">
        <template>
          <div id="qrcodes">
            <vue-qr
              ref="QRCode"
              class="qrcode"
              :text="text"
              :size="200"
            />
          </div>
        </template>
      </el-form>
      <div slot="footer">
        <el-button @click="showDialogVisible = false">
          取 消
        </el-button>
        <el-button type="success" @click="downloadQRCode()">
          下载二维码
        </el-button>
      </div>
    </el-dialog> -->

    <el-form inline size="small">
      <el-form-item label="开始日期">
        <el-date-picker
          v-model="searchForm.startDate"
          type="date"
          clearable
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
        <!-- <el-input v-model="searchForm.startDate" placeholder="请输入开始日期" clearable /> -->
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker
          v-model="searchForm.endDate"
          type="date"
          clearable
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
        <!-- <el-input v-model="searchForm.endDate" placeholder="请输入结束日期" clearable /> -->
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">
          查 询
        </el-button>
      </el-form-item>
    </el-form>

    <el-table
      id="xls-table"
      ref="visitObjectTableRef"
      :data="visitorRecord.list"
      row-key="bid"
      default-expand-all
      :cell-style="{padding: '6px'}"
      :header-cell-style="{background: '#f8f8f9'}"
      @row-click="handleRowClick"
    >
      <el-table-column prop="corporateName" label="公司名称" />
      <el-table-column prop="name" label="姓名" width="100" />
      <el-table-column prop="idCard" label="身份证号" />
      <el-table-column prop="model" label="手机号码" />
      <el-table-column prop="entourage" label="随行人员" />
      <el-table-column prop="appointment" label="预约时间" />
      <el-table-column prop="visit" label="来访事由">
        <template slot-scope="scope">
          <span v-if="scope.row.sex === 1">一般拜访</span>
          <span v-if="scope.row.sex === 2">紧急拜访</span>
          <span v-if="scope.row.sex === 3">产品推介</span>
          <span v-if="scope.row.sex === 4">产品售后</span>
        </template>
      </el-table-column>
      <el-table-column prop="reasonRemarks" label="事由备注" />
    </el-table>
    <el-pagination
      :total="visitorRecord.total"
      :current-page="searchForm.pageNum"
      :page-size="searchForm.pageSize"
      :page-sizes="[10, 15, 20]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      @current-change="pageNumChange"
      @size-change="pageSizeChange"
    />
  </div>
</template>

<script>
import { getVisitorRecord } from '@/api/main/visitor'
export default {
  name: 'visitorRecord',
  data () {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        // hospitalName: '',
        // name: '',
        // realName: '',
        // sex: '',
        // professionalName: ''
      },
      visitorRecord: {
        total: 0,
        list: []
      }
    }
  },
  mounted() {
    this.getMainList()
  },
  // mounted () {
  //   this.getMainList()
  // },
  created () {
    // this.getList()
  },
  methods: {
    getMainList() {
      getVisitorRecord(this.searchForm).then((res) =>{
        console.log(res)
        this.visitorRecord = res
      })
    },
    handleRowClick (row, col, event) {
      this.$refs.visitObjectTableRef.toggleRowExpansion(row)
    },
    pageNumChange (pageNum) {
      this.searchForm.pageNum = pageNum
      this.getMainList()
    },
    pageSizeChange (pageSize) {
      this.searchForm.pageSize = pageSize
      this.pageNumChange(1)
    },
    handleSearch () {
      this.pageNumChange(1)
    },
  }
}
</script>

<style scoped>
    /* #visitObject .qrcode{
        position: relative;
        left: 20px;
    } */
</style>
